<template>
  <div>
    <div v-if="fields.length > 1" class="store-tabs" role="tablist">
      <button
        v-for="field in fields"
        :key="field.type"
        type="button"
        role="tab"
        class="store-tab"
        :class="{ 'is-active': field.type === activeType }"
        :aria-selected="String(field.type === activeType)"
        @click="activeType = field.type"
      >
        {{ field.label }}
        <span v-if="selectedIn(field.type)" class="store-dot"></span>
      </button>
    </div>
    <GenericFacetSelector
      v-if="activeType"
      :key="activeType"
      :type="activeType"
      :options="facets[activeType]"
      :selection="selection"
      @selected="$emit('selected', $event)"
      @removed="$emit('removed', $event)"
    />
    <div v-if="offerValue" class="offer-row">
      <FacetOption
        label="On offer"
        :count="Number(facets[OFFER][offerValue]) || 0"
        :selected="offerSelected"
        @toggle="toggleOffer"
      />
    </div>
  </div>
</template>
<script>
import FacetOption from "./FacetOption.vue";
import GenericFacetSelector from "./GenericFacetSelector.vue";
import {
  ANY_STORE_AVAILABILITY,
  OFFER,
  availabilityStore,
  byLabel
} from "./facetLabels";

// Disponibilidad en cualquier tienda y en cada una, que son los mismos valores
// por otro campo: un solo filtro con una pestaña por campo. Las pestañas sólo
// cambian lo que se ve; lo elegido en otra sigue puesto (punto azul).
export default {
  name: "AvailabilitySelector",
  components: { FacetOption, GenericFacetSelector },
  props: {
    facets: { type: Object, required: true },
    selection: { type: Array, required: true }
  },
  data() {
    return { activeType: null, OFFER };
  },
  computed: {
    fields() {
      const stores = Object.keys(this.facets)
        .filter(type => availabilityStore(type))
        .sort((a, b) => byLabel(availabilityStore(a), availabilityStore(b)))
        .map(type => ({ type, label: availabilityStore(type) }));
      return [
        ...(this.facets[ANY_STORE_AVAILABILITY]
          ? [{ type: ANY_STORE_AVAILABILITY, label: "All" }]
          : []),
        ...stores
      ];
    },
    // "On offer" filtra por is_offer = 1; sin ofertas en los resultados no
    // se muestra.
    offerValue() {
      return Object.keys(this.facets[OFFER] || {}).find(value =>
        /^(1|true)$/i.test(value)
      );
    },
    offerSelected() {
      return this.selection.some(
        item => item.type === OFFER && item.value == this.offerValue
      );
    }
  },
  watch: {
    // La pestaña elegida se mantiene mientras exista; si no, la primera con
    // algo puesto o la primera.
    fields: {
      immediate: true,
      handler(fields) {
        if (fields.some(field => field.type === this.activeType)) return;
        const withSelection = fields.find(field => this.selectedIn(field.type));
        this.activeType = (withSelection || fields[0] || {}).type || null;
      }
    }
  },
  methods: {
    selectedIn(type) {
      return this.selection.some(item => item.type === type);
    },
    toggleOffer() {
      this.$emit(this.offerSelected ? "removed" : "selected", {
        type: OFFER,
        value: this.offerValue,
        valueLabel: "On offer"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.store-tabs {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  overflow: hidden;
}

.store-tab {
  position: relative;
  flex: 1 1 0;
  min-width: 48px;
  padding: 6px 4px;
  font-size: 12px;
  color: #4b5563;
  text-align: center;

  & + & {
    border-left: 1px solid #d1d5db;
  }

  &:hover {
    background: #f3f4f6;
  }

  &.is-active {
    background: #111827;
    color: white;
    font-weight: 600;
  }

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: -2px;
  }
}

.store-dot {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #2563eb;
}

.offer-row {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #e5e7eb;
}
</style>
